import { render, staticRenderFns } from "./VeMayBayList.vue?vue&type=template&id=66a56a9c"
import script from "./VeMayBayList.vue?vue&type=script&lang=js"
export * from "./VeMayBayList.vue?vue&type=script&lang=js"
import style0 from "./VeMayBayList.vue?vue&type=style&index=0&id=66a56a9c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports